import { Widget } from "@rjsf/core";
import { useCallback } from "react";
import { FormMessage } from "@xometry/xometry_loft";
import moment from "moment-business-days";
import LoftDatePicker from "./LoftDatePicker";
import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, ShortText, FullWidth } from "./Shared.style";
import * as types from "../types";
import { FormContext } from "../types";

export const LoftDatePickerWidget: Widget = ({
  disabled,
  required,
  schema,
  rawErrors,
  options,
  onChange,
  onBlur,
  placeholder,
  value,
  formContext,
}) => {
  const handleChange = (datetime: moment.Moment | null) => {
    const isoDate = datetime ? datetime.format("YYYY-MM-DD") : "";
    onChange(isoDate || undefined);
  };

  const dateOptionValues =
    (options?.dateOptionValues as string)?.split(":") || [];

  const disableDate = useCallback<types.DatePickerDisabledDate>(current => {
    let earliestDateAllowed = moment().endOf("day");

    if (dateOptionValues[0] === "includeToday") {
      // allow user to choose today's date
      earliestDateAllowed = earliestDateAllowed.subtract(1, "day");
    } else if (dateOptionValues[0] === "businessDays") {
      // restrict user from choosing the next # of business days
      earliestDateAllowed = earliestDateAllowed.businessAdd(
        +dateOptionValues[1] || 0,
        "day"
      );
    } else if (dateOptionValues[0] === "days") {
      // restrict user from choosing the next # of calendar days
      earliestDateAllowed = earliestDateAllowed.add(
        +dateOptionValues[1] || 0,
        "day"
      );
    }

    return current && current < earliestDateAllowed;
  }, []);

  const defaulDateValue = () => {
    if (dateOptionValues.length === 0) {
      return moment().nextBusinessDay();
    }
    if (dateOptionValues[0] === "includeToday") {
      return moment().endOf("day");
    }
    if (dateOptionValues[0] === "businessDays") {
      return moment()
        .businessAdd(+dateOptionValues[1] || 0, "day")
        .nextBusinessDay();
    }
    if (dateOptionValues[0] === "days") {
      return moment().add(+dateOptionValues[1] || 0, "day");
    }
  };

  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);

  const extraProps: types.ExtraProps = {
    daysDiffIndicator: options?.daysDiffIndicator === true,
    onBlur,
  };
  if (value) {
    extraProps.value = moment(value, "YYYY-MM-DD");
  }

  const { maxWidth } = formContext as FormContext;

  return (
    <div css={[Section, ShortText]}>
      <LabelWithOptionalFlag
        required={required}
        tooltip={(options?.tooltip || "") as string}
      >
        {schema?.title}
      </LabelWithOptionalFlag>
      <LoftDatePicker
        css={FullWidth}
        disabledDate={disableDate}
        onChange={handleChange}
        invalid={isInvalid}
        disabled={disabled}
        placeholder={placeholder || "MM/DD/YYYY"}
        name={options?.name as string}
        maxWidth={maxWidth}
        defaultPickerValue={defaulDateValue()}
        {...extraProps}
      />
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
